module.exports = __webpack_public_path__ + "media/theme/tutorial__psn--5--redeem-ac875a7b.png";